<template>
	<!--
      作者：luoyiming
      时间：2019-10-25
      描述：订单明细
  -->
	<div class="pb50" v-loading="loading">
		<div class="product-content">
			<!--基本信息-->
			<div class="common-form">基本信息</div>
			<div class="table-wrap">
				<el-row>
					<el-col :span="8">
						<div class="pb16">
							<span class="gray9">支付金额：</span>
							{{ detail.pay_price }}
						</div>
					</el-col>
					<el-col :span="8">
						<div class="pb16">
							<span class="gray9">车费：</span>
							{{ detail.coupon_money }}
						</div>
					</el-col>
					<el-col :span="8">
						<div class="pb16">
							<span class="gray9">技师分成（不包含车费）：</span>
							{{ detail.points_money }}
						</div>
					</el-col>
					<el-col :span="8">
						<div class="pb16">
							<span class="gray9">优惠金额：</span>
							{{ detail.points_money }}
						</div>
					</el-col>
					<el-col :span="8">
						<div class="pb16">
							<span class="gray9">退款金额：</span>
							{{ detail.order_price }}
						</div>
					</el-col>
					<el-col :span="8">
						<div class="pb16">
							<span class="gray9">推广佣金：</span>
							{{ detail.express_price }}
						</div>
					</el-col>
					<el-col :span="8">
						<div class="pb16">
							<span class="gray9">下单佣金：</span>
							{{ detail.points_money }}
						</div>
					</el-col>
					<el-col :span="8">
						<div class="pb16">
							<span class="gray9">服务佣金：</span>
							{{ detail.order_price }}
						</div>
					</el-col>
					<el-col :span="8">
						<div class="pb16">
							<span class="gray9">渠道扣款：</span>
							{{ detail.express_price }}
						</div>
					</el-col>
					<el-col :span="8">
						<div class="pb16">
							<span class="gray9">服务扣费：</span>
							{{ detail.points_money }}
						</div>
					</el-col>
					<el-col :span="8">
						<div class="pb16">
							<span class="gray9">储蓄扣费：</span>
							{{ detail.order_price }}
						</div>
					</el-col>
					<el-col :span="8">
						<div class="pb16">
							<span class="gray9">分成比例：</span>
							60%
						</div>
					</el-col>
					<el-col :span="8">
						<div class="pb16">
							<span class="gray9">提现手续费：</span>
							{{ detail.points_money }}
						</div>
					</el-col>
					<el-col :span="8">
						<div class="pb16">
							<span class="gray9">商家分成：</span>
							{{ detail.order_price }}
						</div>
					</el-col>
					<el-col :span="8">
						<div class="pb16">
							<span class="gray9">城市分成：</span>
							{{ detail.order_price }}
						</div>
					</el-col>
					<el-col :span="8">
						<div class="pb16">
							<span class="gray9">补充费用：</span>
							{{ detail.order_price }}
						</div>
					</el-col>
				</el-row>
			</div>

		</div>
	</div>
</template>

<script>
	import OrderApi from '@/api/order.js';
	import {
		deepClone,
	} from '@/utils/base.js';
	export default {
		data() {
			return {
				/*是否加载完成*/
				loading: true,
				/*订单数据*/
				detail: {}
			}
		},
		created(e) {
			/*获取列表*/
			this.getParams();
		},
		methods: {
			
			/*获取参数*/
			getParams() {
				let self = this;
				// 取到路由带过来的参数
				const params = this.$route.query.orderId;
				OrderApi.orderdetail({
							orderId: params
						},
						true
					)
					.then(data => {
						console.log(data)
						self.loading = false;
						self.detail = data.data.detail;
					})
					.catch(error => {
						self.loading = false;
					});
			}

		}
	};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/part/detail.vue